import { useEffect, useState } from 'react';

import { usePostCallAnalysisApi } from '../Services/PostCallAnalysisApiProvider';
import PostCallAnalysisCard from './Chat/PostCallAnalysisCard';

const ChatAnalysisExpandedRow = ({ data }) => {
  const { getThreadAnalysisResults } = usePostCallAnalysisApi();
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    getThreadAnalysisResults(data.thread_key)
      .then((res) => {
        if (!cancelled) setResults(res);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [data.thread_key, getThreadAnalysisResults]);

  if (loading) {
    return <div className="table-folded-content small-font">Loading analysis…</div>;
  }
  if (error) {
    return <div className="table-folded-content small-font">Failed to load analysis.</div>;
  }
  const normalized = Array.isArray(results)
    ? results
    : Array.isArray(results?.items)
      ? results.items
      : results
        ? [results]
        : [];

  if (normalized.length === 0) {
    return <div className="table-folded-content small-font">No analysis available.</div>;
  }

  return (
    <div className="table-folded-content">
      <PostCallAnalysisCard analysisResult={normalized} collapsible={false} />
    </div>
  );
};

export default ChatAnalysisExpandedRow;
